import * as api from '../api'
import { FETCH_ALL_COMPETITION, CREATE_COMPETITION, DELETE_COMPETITION, UPDATE_COMPETITION } from '../constants/actionTypes.js'
import { contrainteNotification, deleteContrainteNotification } from './notifications.js'

// Action creator
export const getCompetitions = () => async (dispatch) => {

    try{
        const {data} = await api.fetchCompetitions()

        dispatch({ type: FETCH_ALL_COMPETITION, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const createCompetition = (competition) => async (dispatch) => {
    try {
        const formData = new FormData()
        Object.keys(competition).forEach((key) => {
            if (competition[key] instanceof Array) {
              for (let i = 0; i < competition[key].length; i++) {
                const value = competition[key][i];
                if (typeof value === 'string') {
                  formData.append(`${key}[]`, value);
                } else {
                    formData.append(`${key}[]`, JSON.stringify(value));
                }
              }
            } else {
              let noNull = competition[key] ?? ""
              formData.append(key, noNull);
            }
          });

        const { data } = await api.createCompetition(formData)

        dispatch( { type : CREATE_COMPETITION, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateCompetition = (id, competition) => async (dispatch) => {
    try {
        const formData = new FormData()
        Object.keys(competition).forEach((key) => {
            if (competition[key] instanceof Array) {
              for (let i = 0; i < competition[key].length; i++) {
                const value = competition[key][i];
                if (typeof value === 'string') {
                  formData.append(`${key}[]`, value);
                } else {
                    formData.append(`${key}[]`, JSON.stringify(value));
                }
              }
            } else {
              // Gère le cas du champs null 
              let noNull = competition[key] ?? ""
              formData.append(key, noNull);
            }
          });

        const { data } = await api.updateCompetition(id, formData)

        dispatch({ type : UPDATE_COMPETITION, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const deleteCompetition = (id, callback) => async (dispatch) => {
    try {

        await api.deleteCompetition(id)

        dispatch(deleteContrainteNotification(id))

        callback(id)

        dispatch({ type : DELETE_COMPETITION, payload: id})
    }catch(error){
        const {error : serverError} = error.response.data

        const {statusCode, type, typeObject, idObject} = serverError

        if(statusCode===409 && type==='constraint'){
            // Un autre object doit etre supprimé avant
            dispatch(contrainteNotification(idObject, typeObject))
        }
    }
}